import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';

import {SharedModule} from '../../../../core/modules/shared.module';
import {AddOrganisationDialogComponent} from './add.organisation.dialog.component';


const routes =
    [{path: 'organisationsdialog', component: AddOrganisationDialogComponent}];

@NgModule({
  declarations: [AddOrganisationDialogComponent],
  imports: [SharedModule, RouterModule.forChild(routes)],
  exports: [AddOrganisationDialogComponent]
})

export class AddOrganisationModule {}


// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/main/content/organisations/add/add.organisation.dialog.module.ts